<template>
  <div>
    <!--  头部模板  -->
    <header-yjj></header-yjj>
    <header-img-yjj></header-img-yjj>
    <div class="container">
      <p class="nav">当前位置：首页——陈列展览</p>
        <div class="content">
          <div class="leftNav">
            <h2>栏目导航</h2>
            <div>
              <ul>
                <router-link to="" v-for="item in navList" :key="item.index">
                  <li :class="{active:activeFlag == item.flag}" @click="navCur(item.flag,item.columnId)">
                    <h4>{{ item.name }}</h4>
                    <p style="font-size: 14px;">{{ item.des}}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>

          <div class="rightCol">
            <div class="rightCol-c">
              <h2>
                <span>陈列展览</span>
              </h2>
              <div class="wrap" >
                <div class="item" v-for="item in articleData" :key="item.index">
                    <h2>{{ item.title }}</h2>
                    <img :src="item.imgsrc" style="width: 100%">
                </div>

                <div class="pageBtn">
                  <div class="prev" >
                    <el-button type="danger" @click="prev(columnId)">上一页</el-button>

                  </div>
                  <div class="next">
                    <el-button type="danger" @click="next(columnId)">下一页</el-button>
                  </div>
                </div>

              </div>
            </div>

          </div>



        </div>

<!--      <div class="content" v-for="item in articleData" :key="item.index">-->
<!--        <h2>{{ item.title }}</h2>-->

<!--      </div>-->


    </div>



    <!--  底部模板  -->
    <footer-yjj></footer-yjj>
  </div>
</template>

<script>
import HeaderYjj from "@/components/yjj/HeaderYjj";
import FooterYjj from "@/components/yjj/FooterYjj";
import HeaderImgYjj from "@/components/yjj/HeaderImgYjj";
import {request} from "@/request/request";

export default {
  name: "ImgContentYjj",
  components: {
    HeaderYjj,
    FooterYjj,
    HeaderImgYjj
  },
  data(){
    return{
      restfulUrl:'displays',
      articleData: [],
      navList:[
        {id:1,columnId:'1',name:'民族烽火',des:'东北抗日义勇军序厅',flag:1},
        {id:2,columnId:'2',name:'奋起抵抗',des:'东北抗日义勇军早期抗战',flag:2},
        {id:3,columnId:'3',name:'浴血奋战',des:'东北抗日义勇军英勇抗战',flag:3},
        {id:4,columnId:'4',name:'不屈不挠',des:'东北抗日义勇军英勇抗战',flag:4},
        {id:5,columnId:'5',name:'时代强音',des:'东北抗日义勇军与《义勇军进行曲》',flag:5},
        {id:6,columnId:'6',name:'英灵永驻',des:'东北抗日义勇军将士名录厅',flag:6}
      ],
      activeFlag:1,
      total:0,
      current:1,
      columnId:1,
      navTitle:'',
    }
  },
  methods:{
    navCur(data,columnId){
      this.columnId = columnId;
      this.activeFlag = data;
      this.getListByColumn({page:1,pageSize:1,columnId:data});
    },
    prev(){
      request({
        method:'GET',
        url:this.restfulUrl+'/prev/'+this.$route.params.id,
        params:{columnId:this.columnId}
      }).then(res =>{
        if(res.data.code==0){
          return false
        }
        else{
          var dataList = []
          dataList.push(res.data);
          this.articleData = dataList;
          this.$router.push({
            path:'/yjj/pic/'+res.data.id
          })
        }

      },err=>{
        console.log(err)
      })
    },
    next(){
      request({
        method:'GET',
        url:this.restfulUrl+'/next/'+this.$route.params.id,
        params:{columnId:this.columnId}
      }).then(res =>{
        if(res.data.code==0){
          return false
        }
        else{
          var dataList = []
          dataList.push(res.data);
          this.articleData = dataList;
          this.$router.push({
            path:'/yjj/pic/'+res.data.id
          })
        }

      },err=>{
        console.log(err)
      })
    },
    getListByColumn(params){
      request({
        method:'GET',
        url:this.restfulUrl+'/page',
        params:params
      }).then(res =>{
        this.articleData = res.data.records;
        this.total = res.data.total;
        this.current = res.data.current;

      },err=>{
        console.log(err)
      })
    },
    getListById(uid){
      request({
        method:'GET',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        this.columnId = res.data.columnId;
        this.articleData.push(res.data);

      },err=>{
        console.log(err)
      })
    },

  },
  mounted() {
    this.getListById(this.$route.params.id)
    // console.log(this.$route)
    // this.getListByColumn({page:1,pageSize:1,columnId:1});
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>


.container{
  width:70%;
  margin: 0 auto;
  padding:10px 0;
}
.active{
  color:#9E1A28;
  font-weight: bold;
}
.nav{
  text-align: left;
}
.content{
  display: flex;
  margin-top: 20px;
}
.content .leftNav{
  flex:1
}
.leftNav h2{
  color: white;
  height: 60px;
  line-height: 60px;
  background: #9E1A28;
}
.leftNav div{
  margin-top: 10px;
  border: 1px solid silver;
}
.leftNav div{
  padding-bottom: 20px;
}
.leftNav div ul{
  padding:0 20px;
}
.leftNav div ul li {

  padding: 15px 0;
  line-height: 25px;
  border-bottom: 1px silver dashed;
}
.leftNav div ul a{
  color: black;
  text-decoration: none;
}
.rightCol{
  flex: 4;

}
.rightCol-c{
  padding:10px 0 0 60px;
}
.rightCol-c h2{
  padding-bottom: 10px;
  border-bottom: 1px solid silver;
  text-align: left;
}
.rightCol-c h2 span{
  color: #9E1A28;
  padding-bottom: 6px;
  border-bottom: 5px solid #9E1A28;
}
.wrap{
  padding:20px;
}

.item {

}

.item h2{
  padding: 20px 0;
  text-align: center;
  border-bottom: 1px solid silver;
  margin-bottom: 20px;
}
.item img{
  width:100%;

}
.pageBtn{
  display: flex;
  margin-top: 20px;
}
.prev,.next{
  flex:1;



}
.prev button,.next button{
  background: #9E1A28;
}
.prev{
  text-align: left;
}
.next{
  text-align: right;
}
.disabled{

}
</style>
